module.exports = "<div class=\"global-progress-bar\" [ngClass]=\"{'active': doDisplayIndicator, '': !doDisplayIndicator}\">\n  <img src=\"assets/interwind.gif\" class=\"spinner\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/components/loader/loader.component.html
// module id = ../../../../../src/app/modules/common/ngx-http-loader/loader-service/components/loader/loader.component.html
// module chunks = main